import { api } from "./client.js";
const VIOLATION_LABEL = {
    venue_not_allowed: () => "Venue isn't in your permitted list.",
    day_not_allowed: () => "Selected day is outside your allowed windows for this venue.",
    time_outside_window: (v) => {
        const r = typeof v.requested === "object" && v.requested ? v.requested : null;
        return r?.from && r?.to
            ? `${r.from}–${r.to} is outside your allowed windows.`
            : "Selected time is outside your allowed windows.";
    },
    courts_exceed_cap: (v) => {
        const cap = v.cap ?? 0;
        const req = typeof v.requested === "number" ? v.requested : undefined;
        return req !== undefined
            ? `Asking for ${req} courts but this window allows up to ${cap}.`
            : `Court count exceeds the limit (${cap}) for this window.`;
    },
};
export function humaniseViolation(v) {
    const key = v.type ?? v.code ?? "";
    const fmt = VIOLATION_LABEL[key];
    if (fmt)
        return fmt(v);
    return v.message ?? "Doesn't fit your current permissions.";
}
export const rulesApi = {
    list: () => api.get("api/rules").json(),
    detail: (id) => api.get(`api/rules/${id}`).json(),
    create: (body) => api.post("api/rules", { json: body }).json(),
    update: (id, body) => api.patch(`api/rules/${id}`, { json: body }).json(),
    enable: (id) => api.post(`api/rules/${id}/enable`).json(),
    disable: (id) => api.post(`api/rules/${id}/disable`).json(),
    delete: (id) => api
        .delete(`api/rules/${id}`)
        .json(),
    rerunWeek: (id, weekStartISO) => api
        .post(`api/rules/${id}/rerun-week`, { json: { weekStartISO } })
        .json(),
    createNextSession: (id) => api
        .post(`api/rules/${id}/create-next-session`)
        .json(),
    bulkBookings: (venueId) => api.get("api/rules/bulk-bookings", { searchParams: { venueId } }).json(),
};
